/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Offset_HelpInputs */

const en_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset from shot change in frames`)
};

const fr_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décalage par rapport au changement de plan en images`)
};

const de_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebung durch Szenenwechsel in Frames`)
};

const it_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset dal cambio di inquadratura nei fotogrammi`)
};

const ru_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение из-за смены кадра`)
};

const es_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento del cambio de toma en los fotogramas`)
};

const zh_cn2_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头切换引起的偏移量`)
};

const ja_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム内のショット変更からのオフセット`)
};

const hi_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम में शॉट परिवर्तन से ऑफसेट`)
};

const pt_pt2_shot_change_offset_help = /** @type {(inputs: Shot_Change_Offset_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento da mudança de enquadramento em frames`)
};

/**
* | output |
* | --- |
* | "Offset from shot change in frames" |
*
* @param {Shot_Change_Offset_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_offset_help = /** @type {((inputs?: Shot_Change_Offset_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Offset_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shot_change_offset_help(inputs)
	if (locale === "de") return de_shot_change_offset_help(inputs)
	if (locale === "it") return it_shot_change_offset_help(inputs)
	if (locale === "ru") return ru_shot_change_offset_help(inputs)
	if (locale === "es") return es_shot_change_offset_help(inputs)
	if (locale === "zh-CN") return zh_cn2_shot_change_offset_help(inputs)
	if (locale === "ja") return ja_shot_change_offset_help(inputs)
	if (locale === "hi") return hi_shot_change_offset_help(inputs)
	if (locale === "pt-PT") return pt_pt2_shot_change_offset_help(inputs)
	return en_shot_change_offset_help(inputs)
});